<template>
  <div ref="root">
    <header class="app-header">
      <div class="app-header__home">
        <div class="app-header__left">
          <div class="app-header__logo" @click="clickHome">
            <img v-if="chainLogo" :src="chainLogo" />
            <div v-else-if="chainName" class="app-header__store-name">
              {{ chainName }}
            </div>
          </div>
          <div
            v-if="
              isViewerComponent &&
              route.name === 'chirashi-viewer' &&
              isContentLoaded
            "
            class="app-header__chirashi-title"
            :class="{ 'is-flyer-view': isFlyerView }"
          >
            <NuxtLink
              v-if="isContentLoaded"
              :to="returnLink"
              exact
              class="app-header__chirashi-title-header"
              @click="clearDetailId"
            >
              <h2>{{ isSingleStore ? chainName : flyerViewerItem.shopName }}のチラシ</h2>
            </NuxtLink>
            <div
              v-if="isFlyerView"
              class="app-header__chirashi-title-container"
            >
              <span
                v-if="flyerViewerItem.title && isFlyerView"
                class="app-header__chirashi-title-text"
                @mouseover="onTitleMouseOver"
                @mouseleave="onTitleMouseLeave"
                >{{ flyerViewerItem.title }}</span
              >
              <div
                class="app-header__chirashi-tooltip"
                :class="{ 'tooltip-visible': tooltipVisible }"
              >
                <div class="app-header__chirashi-tooltip-arrow"></div>
                <span>{{ flyerViewerItem.title }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="app-header__nav">
          <nuxt-link
            v-if="!cookieError && !isSingleStore"
            :class="['app-header__link', 'app-header__viewer-link', { 'active-link': isSearchScreen }]"
            :to="searchStoreLink"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.5001 13.9999H14.7101L14.4301 13.7299C15.6301 12.3299 16.2501 10.4199 15.9101 8.38989C15.4401 5.60989 13.1201 3.38989 10.3201 3.04989C6.09014 2.52989 2.53014 6.08989 3.05014 10.3199C3.39014 13.1199 5.61014 15.4399 8.39014 15.9099C10.4201 16.2499 12.3301 15.6299 13.7301 14.4299L14.0001 14.7099V15.4999L18.2501 19.7499C18.6601 20.1599 19.3301 20.1599 19.7401 19.7499C20.1501 19.3399 20.1501 18.6699 19.7401 18.2599L15.5001 13.9999ZM9.50014 13.9999C7.01014 13.9999 5.00014 11.9899 5.00014 9.49989C5.00014 7.00989 7.01014 4.99989 9.50014 4.99989C11.9901 4.99989 14.0001 7.00989 14.0001 9.49989C14.0001 11.9899 11.9901 13.9999 9.50014 13.9999Z"
                fill="#222222"
              />
            </svg>
            店舗をさがす
          </nuxt-link>
          <div v-if="!cookieError" class="app-header__hamburger" @click="isOpen = true">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 42 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 2H40"
                stroke="#222222"
                stroke-width="3"
                stroke-linecap="round"
              />
              <path
                d="M2 14H40"
                stroke="#222222"
                stroke-width="3"
                stroke-linecap="round"
              />
              <path
                d="M2 26H40"
                stroke="#222222"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </header>
    <div class="app-header app-header__scroll" :class="{ active: isFixed }">
      <div class="app-header__home">
        <div class="app-header__left">
          <div class="app-header__logo" @click="clickHome">
            <img v-if="chainLogo" :src="chainLogo" />
            <div v-else-if="chainName" class="app-header__store-name">
              {{ chainName }}
            </div>
          </div>
          <div
            v-if="
              isViewerComponent &&
              route.name === 'chirashi-viewer' &&
              isContentLoaded
            "
            class="app-header__chirashi-title"
            :class="{ 'is-flyer-view': isFlyerView }"
          >
            <nuxt-link
              v-if="isContentLoaded"
              :to="returnLink"
              exact
              class="app-header__chirashi-title-header"
            >
              <h2>{{ isSingleStore ? chainName : flyerViewerItem.shopName }}のチラシ</h2>
            </nuxt-link>
            <div
              v-if="isFlyerView"
              class="app-header__chirashi-title-container"
            >
              <span
                v-if="flyerViewerItem.title && isFlyerView"
                class="app-header__chirashi-title-text"
                @mouseover="onTitleMouseOver"
                @mouseleave="onTitleMouseLeave"
                >{{ flyerViewerItem.title }}</span
              >
              <div
                class="app-header__chirashi-tooltip"
                :class="{ 'tooltip-visible': tooltipVisible }"
              >
                <div class="app-header__chirashi-tooltip-arrow"></div>
                <span>{{ flyerViewerItem.title }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="app-header__nav">
          <nuxt-link
            v-if="!cookieError && !isSingleStore"
            :class="[
              'app-header__link',
              'app-header__viewer-link',
              { 'active-link': isSearchScreen }
            ]"
            :to="searchStoreLink"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.5001 13.9999H14.7101L14.4301 13.7299C15.6301 12.3299 16.2501 10.4199 15.9101 8.38989C15.4401 5.60989 13.1201 3.38989 10.3201 3.04989C6.09014 2.52989 2.53014 6.08989 3.05014 10.3199C3.39014 13.1199 5.61014 15.4399 8.39014 15.9099C10.4201 16.2499 12.3301 15.6299 13.7301 14.4299L14.0001 14.7099V15.4999L18.2501 19.7499C18.6601 20.1599 19.3301 20.1599 19.7401 19.7499C20.1501 19.3399 20.1501 18.6699 19.7401 18.2599L15.5001 13.9999ZM9.50014 13.9999C7.01014 13.9999 5.00014 11.9899 5.00014 9.49989C5.00014 7.00989 7.01014 4.99989 9.50014 4.99989C11.9901 4.99989 14.0001 7.00989 14.0001 9.49989C14.0001 11.9899 11.9901 13.9999 9.50014 13.9999Z"
                fill="#222222"
              />
            </svg>
            店舗をさがす
          </nuxt-link>
          <div class="app-header__hamburger" @click="isOpen = true">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 42 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 2H40"
                stroke="#222222"
                stroke-width="3"
                stroke-linecap="round"
              />
              <path
                d="M2 14H40"
                stroke="#222222"
                stroke-width="3"
                stroke-linecap="round"
              />
              <path
                d="M2 26H40"
                stroke="#222222"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <PCSideMenu
      :is-open="isOpen"
      :utm-source="utmSource"
      @close="isOpen = false"
    />
  </div>
</template>

<script setup>
import PCSideMenu from '@/components/PCSideMenu'
import { useRoute, useRouter } from 'vue-router'
import { useChirashiStore } from '@/stores/chirashi';

const route = useRoute()
const router = useRouter()
const chirashiStore = useChirashiStore()
const runtimeConfig = useRuntimeConfig()

const { $isSp } = useNuxtApp()

const props = defineProps({
  /**
   * chainタイプ
   * @values marui
   */
  chainType: {
    type: String,
    default: '',
  },
  currentPage: {
    type: String,
    default: 'ホーム',
  },
  chirashi: {
    type: Boolean,
    default: null,
  },
  pointBenefits: {
    type: Boolean,
    default: null,
  },
  chainLogo: {
    type: String,
    default: null,
  },
  chainName: {
    type: String,
    default: null,
  },
  returnLink: {
    type: String,
    default: null,
  },
  utmSource: {
    type: [Number, String, null],
    default: null,
  },
  isViewerComponent: {
    type: Boolean,
    default: false,
  },
  isContentLoaded: {
    type: Boolean,
    default: false,
  },
  flyerViewerItem: {
    type: Object,
    default: () => {},
  },
  flyerViewerDate: {
    type: Object,
    default: () => {},
  },
  cookieError: {
    type: Boolean,
    default: false,
  },
  chainName: {
    type: String,
    default: '',
  },
})

const card = ref(true)
const observer = ref(null)
const isFixed = ref(false)
const isOpen = ref(false)
const isMobile = ref(false)
const tooltipVisible = ref(false)
const root = ref(null)

const isFlyerView = computed(() => {
  return true
})

const isSearchScreen = computed(() => {
  return route.name === 'mystore-search' || route.name === 'mystore-type'
})

const searchStoreLink = computed(() => {
  if (props.utmSource) {
    return `/my-store/search?utm_source=${props.utmSource}`
  }
  return '/my-store/search'
})

const isSingleStore = computed(() => {
  return runtimeConfig.public.singleStore
})

const observeIntersect = () => {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  }
  const handleIntersect = (entries, observer) => {
    entries.forEach(entry => {
      isFixed.value = !entry.isIntersecting
    })
  }
  observer.value = new IntersectionObserver(handleIntersect, options)
  observer.value.observe(root.value.children[0])
}

const clickHome = () => {
  if (props.cookieError) return
  chirashiStore.$patch({ activeDetailId: null })
  if (route.name === 'chirashi') {
    window.location.reload()
  } else {
    router.push(props.returnLink)
  }
}

const onResize = () => {
  isMobile.value = $isSp(window.innerWidth)
}

const onTitleMouseOver = () => {
  tooltipVisible.value = true
}

const onTitleMouseLeave = () => {
  tooltipVisible.value = false
}

const clearDetailId = () => {
  chirashiStore.$patch({ activeDetailId: null })
}

onMounted(() => {
  observeIntersect()
  onResize()
  window.addEventListener('resize', onResize)
})
</script>

<style lang="scss" scoped>
.app-header {
  display: none;
  @media screen and (min-width: $tablet-breakpoint) {
    display: block;
    width: 100%;
    background-color: transparent;
    box-sizing: border-box;
    height: 8.9rem;
  }
}

.app-header__home {
  display: none;
  @media screen and (min-width: $tablet-breakpoint) {
    display: flex;
    align-items: center;
    background: transparent;
    justify-content: space-between;
    height: 100%;
    padding: 0 2.4rem;
    margin: auto;
    box-sizing: border-box;
    max-width: 100%;
  }
  @media screen and (min-width: $pc-breakpoint) {
    padding: 0 4rem;
  }
}

.app-header__left {
  display: flex;
  align-items: center;
  gap: 1.6rem;
  min-width: 0;
}
.app-header__link {
  display: block;
  font-weight: 700;
  font-size: 1.6rem;
  line-height: calc(23.17 / 16);
  color: $color-main-text;
  padding: 0.4rem 2rem;
  border-bottom: 0.2rem solid transparent;
  @media screen and (min-width: $pc-breakpoint) {
    font-size: 17px;
  }
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
.app-header__viewer-link {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0;
  margin: 0.4rem 2rem;

  @media screen and (min-width: $pc-breakpoint) {
    font-size: 17px;
  }
}
.app-header__logo,
.home__header-logo {
  position: relative;
  right: 0;
  left: 0;
  margin: 0;
  height: 4.3rem;
  text-align: center;
  cursor: pointer;
  img {
    height: 100%;
    // image-rendering: -webkit-optimize-contrast;
  }
}
.app-header__store-name {
  color: $color-main-text;
  font-weight: 700;
  font-size: 2rem;
  line-height: calc(28.96 / 20);
}

.app-header__chirashi-title-container {
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.app-header__chirashi-title {
  display: flex;
  gap: 1.6rem;
  align-items: center;
  min-width: 0;
  .app-header__chirashi-title-header {
    flex-shrink: 0;
    h2 {
      font-size: 1.6rem;
      font-weight: 700;
      color: $color-main-text;
      text-decoration: underline;
    }
  }
  .app-header__chirashi-title-text {
    font-size: 1.6rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
      cursor: pointer;
    }
  }
  .app-header__chirashi-tooltip {
    position: absolute;
    font-size: 1.6rem;
    color: $color-white;
    background: rgba(0, 0, 0, 0.5);
    padding: 0.8rem;
    border-radius: 0.4rem;
    top: 7rem;
    max-width: 95vw;
    white-space: pre-line;
    opacity: 0;
    transition: opacity 0.3s;
    &.tooltip-visible {
      opacity: 1;
    }
  }
  .app-header__chirashi-tooltip-arrow {
    width: 0;
    height: 0;
    position: absolute;
    top: -12px;
    left: calc(50% - 0.4rem);
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 12px solid rgba(0, 0, 0, 0.5);
  }
}
.app-header__menu {
  display: flex;
  height: 2.5rem;
  width: 4.8rem;
  align-items: center;
  padding-left: 2rem;
  cursor: pointer;
}
.app-header__nav {
  padding: 0;
  z-index: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  & > .active-link {
    color: $color-main;
    border-color: $color-main;
    & > svg > path {
      fill: $color-main;
    }
  }
}

.app-header__hamburger {
  width: 3.8rem;
  height: 2.4rem;
  cursor: pointer;
  margin-left: 2rem;
}

.app-header__scroll {
  position: fixed;
  background: #faf9f8;
  top: 0;
  transform: translateY(-100%);
  transition: opacity 0.2s ease, transform 0s 0.2s ease;
  opacity: 0;
  will-change: opacity;
  left: 0;
  right: 0;
  margin: auto;
  &.active {
    transform: translateY(0);
    opacity: 1;
    transition: opacity 0s ease, transform 0.2s ease;
  }
}
</style>
